---
en:
  marketplace:
    add_now: Add now
    add_tags: Add tags
    body: Main text
    card_info: Card info
    confirmation: Are you sure?
    contact_info: Contact info
    filter: Filter based on category
    heading: Marketplace
    image: Image
    image_to_large: Image size should be less than 5 MB!
    tags: Tags
    unexpected_error: An unexpected error occurred
